import { format } from "date-fns";

export interface MonthLabel {
	label: string;
	value: string;
}

export interface GetParticipationDateRangeLabelsParams {
	filterStartDate: Date | null;
	filterEndDate: Date | null;
	oldestDataDate: Date | null;
	today?: Date;
}

export const getParticipationDateRangeLabels = ({
	filterStartDate,
	filterEndDate,
	oldestDataDate,
	today = new Date(),
}: GetParticipationDateRangeLabelsParams): MonthLabel[] => {
	const labels: MonthLabel[] = [];
	const currentDate = filterStartDate
		? new Date(filterStartDate.getTime())
		: oldestDataDate
			? new Date(oldestDataDate.getTime())
			: new Date(today.getTime());
	const effectiveEndDate = filterEndDate ? new Date(filterEndDate.getTime()) : new Date(today.getTime());

	while (currentDate <= effectiveEndDate) {
		const month = currentDate.getMonth() + 1; // getMonth is zero-based
		const year = currentDate.getFullYear();
		const monthValue = `${year}-${month.toString().padStart(2, "0")}`;
		const monthLabel = format(currentDate, "MMM");
		labels.push({ label: monthLabel, value: monthValue });
		currentDate.setMonth(currentDate.getMonth() + 1);
	}

	return labels;
};
